namespace $.$$ {

	$mol_style_define( $bog_gamengine_demo_boxes, {

		flex: {
			grow: 1,
		},
		'>': {
			$mol_scroll: {
				'>': {
					$mol_view: {
						alignSelf: 'stretch',
					},
				},
			},
		},

	} )

}
